import React from "react";
import logo from "./assets/logo.png";
import "./Home.css";

// Games shown in the "Our Projects" section — add new games here.
const SHOT = "https://is1-ssl.mzstatic.com/image/thumb/";
const projects = [
  {
    name: "Submarine Quest: Merge&Explore",
    tagline: "Merge & Match Sea Life Puzzle",
    description:
      "Dive from the sunlit shallows to the midnight depths. Merge sea life, discover deep-sea creatures and upgrade your submarine.",
    icon: "/submarinequest-icon.png",
    // [left, center, right] screenshots
    shots: [
      SHOT + "PurpleSource211/v4/89/2a/34/892a346e-6563-131f-96aa-90a5ddc298b4/iphone_2.png/600x1300bb-60.jpg",
      SHOT + "PurpleSource211/v4/8a/d3/5e/8ad35e9f-7d6e-c4d3-35ae-1d89e04b971d/iphone_5.png/600x1300bb-60.jpg",
      SHOT + "PurpleSource221/v4/dd/e8/f3/dde8f389-a7e5-3746-54b2-21848de41982/iphone_2.png/600x1300bb-60.jpg",
    ],
    tags: ["Puzzle", "Merge", "iOS", "Android"],
    href: "/submarinequest",
  },
];

function Home() {
  return (
    <div className="home">
      <header className="site-header">
        <a className="site-logo" href="/"><img src="/khaolam-logo.png" alt="KhaoLam Interactive" /></a>
        <nav className="site-nav">
          <a href="/#projects">Projects</a>
          <a href="mailto:tech@khaolam.com">Contact</a>
        </nav>
      </header>

      <section className="home-hero">
        <img src={logo} alt="KhaoLam Interactive" />
        <p className="home-motto">"The art of craft, the craft of play."</p>
      </section>

      <section className="home-projects" id="projects">
        <h2 className="home-heading">Our Projects</h2>
        <div className="home-grid">
          {projects.map((p) => (
            // Plain <a> (not router Link) so the static game page loads with a full page request.
            <a className="project-card" key={p.href} href={p.href}>
              <div className="project-body">
                <div className="project-head">
                  <img className="project-icon" src={p.icon} alt="" />
                  <div>
                    <p className="project-name">{p.name}</p>
                    <p className="project-tagline">{p.tagline}</p>
                  </div>
                </div>
                <p className="project-desc">{p.description}</p>
                <div className="project-tags">
                  {p.tags.map((t) => <span key={t}>{t}</span>)}
                </div>
                <span className="project-cta">View game</span>
              </div>
              <div className="project-showcase" aria-hidden="true">
                <img className="shot-left" src={p.shots[0]} alt="" />
                <img className="shot-right" src={p.shots[2]} alt="" />
                <img className="shot-center" src={p.shots[1]} alt="" />
              </div>
            </a>
          ))}
        </div>
      </section>

      <footer className="home-footer">
        <p className="home-footer-title">Let's work together</p>
        <p className="home-footer-text">Publishing, partnerships or just saying hi — we'd love to hear from you.</p>
        <a className="home-btn" href="mailto:tech@khaolam.com">Contact Us</a>
        <p className="home-copy">© KhaoLam Interactive Co., Ltd.</p>
      </footer>
    </div>
  );
}

export default Home;
